<template>
  <div class="data-usage-warning" v-if="visible">
    <div class="warning-content">
      <p>{{ $t("dataUsage.warning") }}</p>
      <br />
      <button @click="closeModal">{{ $t("buttons.ok") }}</button>
      &nbsp;&nbsp;
      <button @click="redirectToHomepage">{{ $t("buttons.backToHomepage") }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DataUsageWarning",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    redirectToHomepage() {
      window.location.href = "https://geocraft.nl";
    },
  },
};
</script>

<style scoped>
.data-usage-warning {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 30%;
  padding-left: 33%;
  padding-right: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: all;
}

.warning-content {
  background: white;
  color: #111;
  padding: 30px;
  border-radius: 5px;
  text-align: center;
  pointer-events: auto;
}
</style>
